module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay.9bc49770.png";